import { postPartnerIqContactsCompute } from '../../oppsync/api/PartnerIq'

/**
 * Triggers AWS Engine PartnerIQ contacts compute. Safe to call when PartnerIQ is
 * newly enabled; failures are logged and do not block onboarding or admin saves.
 */
export const triggerPartnerIqContactsCompute = async (
  partnerId: string
): Promise<void> => {
  if (!partnerId) return

  try {
    await postPartnerIqContactsCompute(partnerId)
  } catch (error) {
    console.warn(
      '[PartnerIQ] Contacts compute request failed for partner',
      partnerId,
      error
    )
  }
}
